module.exports = __webpack_public_path__ + "img/06供应链领域.30018c0c.jpg";